import React, { useContext } from 'react';
import twMerge from 'utilities/src/twMerge';
import ThemeContext from '../_themeContext';
import LinkGroup from './_LinkGroup';

interface Props {
  links: { label: string; href: string }[][];
  className?: string;
}

export default function Links({ links, className }: Props) {
  const { theme } = useContext(ThemeContext);
  return (
    <ul
      className={twMerge(
        'mdS:absolute mdS:py-0 left-0 top-0 w-full py-3',
        'mdS:flex mdS:h-full',
        'text-site-neutrals-0 mdS:text-site-neutrals-400',
        { 'mdS:text-site-neutrals-50': theme === 'dark' },
        className,
      )}
    >
      {links.map((linkList, index) => (
        <li key={linkList[0].label} className="mdS:overflow-visible group relative flex flex-col overflow-hidden">
          <LinkGroup links={linkList} index={index} />
        </li>
      ))}
    </ul>
  );
}
